import React, { Component, Fragment } from "react";
import ReactDOM from "react-dom";
import Chatbox from "./chatbox";
import Mcq from "./mcq";
import Typing from "./typing";
import { LeftBox, RightBox } from "./boxes";
import getLabel from './../../utils/labels'
import "./container.css";
class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			displayScrollInfo: false,
			shouldScroll: true
		};
	}

	scrollToBottom = () => {
		const node = ReactDOM.findDOMNode(this.messagesEnd);
		if (node) {
			node.scrollIntoView(true, {
				behavior: "smooth"
			});
		}
	};
	componentDidMount() {
		window.as = this;
		window.addEventListener("scroll", this.isScrolledIntoView, true);
		this.scrollToBottom();
	}

	componentDidUpdate() {
		this.isScrolledIntoView();
		if (this.state.shouldScroll) {
			this.scrollToBottom();
			this.setState({
				shouldScroll: false
			});
		}
	}

	componentWillReceiveProps = nextProps => {
		if (nextProps.chats.length > this.props.chats.length) {
			this.setState({
				shouldScroll: true
			});
		}
	};

	isScrolledIntoView = () => {
		const node = ReactDOM.findDOMNode(this.rightBoxChat);
		if (node) {
			let rect = node.getBoundingClientRect();
			let elemBottom = rect.bottom;
			if (elemBottom <= this.props.chatBoxSize) {
				if (this.state.displayScrollInfo) {
					this.setState({
						displayScrollInfo: false
					});
				}
			} else {
				if (!this.state.displayScrollInfo) {
					this.setState({
						displayScrollInfo: true
					});
				}
			}
		}
	};

	render() {
		const {
			chats,
			userClickedOnSubmit,
			selfActor,
			chatContainerHeight,
			selfActorImage
		} = this.props;

		let box, iter, actor;
		const ele = chats.map((chat, i) => {
			// actor = actors.find((actor) => actor === chat.fromActor);
			iter = i;
			switch (chat.type) {
				case "statement":
					box = (
						<Chatbox
							{...chat}
							key={i}
							afterStatementEnds={this.props.afterStatementEnds}
						/>
					);
					break;
				case "mcq":
					// actor = actors.find((actor) => actor === chat.fromActor);
					box = (
						<Mcq
							{...chat}
							key={i}
							userClickedOnSubmit={userClickedOnSubmit}
							//For tutorial
							tutorial={this.props.tutorial}
							startTutorial={this.props.startTutorial}
							stopTutorial={this.props.stopTutorial}
							addStepsToTutorial={this.props.addStepsToTutorial}
							updateStepNumber={this.props.updateStepNumber}
						/>
					);
					break;
				case "typing":
					box = <Typing {...chat} key={i} />;
				default:
					break;
			}
			return chat.fromActor != selfActor ? (
				<LeftBox
					key={iter}
					actor={chat.fromActor}
					actors={this.props.actors}
					ref={el => {
						this.messagesEnd = el;
					}}
				>
					{box}
					<div className="clear-all" />
				</LeftBox>
			) : (
					<RightBox
						key={iter}
						actor={chat.fromActor}
						actors={this.props.actors}
						selfActorImage={selfActorImage}
						ref={el => {
							this.rightBoxChat = el;
						}}
					>
						{box}
						<div className="clear-all" />
					</RightBox>
				);
		});
		return (
			<div
				className="chat-app-container"
				style={{
					maxHeight: chatContainerHeight,
					minWidth: this.props.width,
					height: "100%"
				}}
			>
				<div className="chat-place">{ele}</div>
				{this.state.displayScrollInfo ? (
					<div className="scroll-holder">
						<div className="scroll-text">
							{getLabel('label_scroll_down_text')}
						</div>
					</div>
				) : null}
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// /src/call/container/container.js